import React from "react";
import PropTypes from "prop-types";
import IllustrationIntelligentPricing from "../../illustrations/IllustrationIntelligentPricing";
import Preview from "./LivePreview";

function LivePreviewIntelligentPricing({ title }) {
  return (
    <Preview
      illustration={<IllustrationIntelligentPricing />}
      title={title}
      subTitle="Pricing Matters"
    />
  );
}

LivePreviewIntelligentPricing.propTypes = {
  title: PropTypes.string.isRequired
};

export default LivePreviewIntelligentPricing;
